export interface StatsState {
  prevRouteTitle: string;
  prevRouteUrl: string;
  currentRouteTitle: string;
  currentRouteUrl: string;
}

export const SET_PREV_ROUTE = 'SET_PREV_ROUTE';
export const SET_CURRENT_ROUTE = 'SET_CURRENT_ROUTE';

interface SetPrevRouteAction {
  type: typeof SET_PREV_ROUTE;
  url: string;
  title: string;
}

interface SetCurrentRouteAction {
  type: typeof SET_CURRENT_ROUTE;
  url: string;
  title: string;
}

export type StatsActionTypes = SetPrevRouteAction | SetCurrentRouteAction;
